import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 100
    }
  },
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  title: {
    fontSize: '25px',
    fontWeight: 500,
    color: theme.palette.common.black,
    textAlign: 'center',
    paddingTop: '32px'
  },
  gridItem: {
    padding: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '8px'
    }
  },
  photoTitle: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
    padding: '10px 0px'
  },
  photo: {
    border: `2px dotted ${theme.palette.primary.main}`,
    borderRadius: 14,
    boxShadow: '-3px -2px 0px 4px #d1cccc,3px 2px 0px 4px #d1cccc',
    width: '100%',
    maxHeight: '300px',
    objectFit: 'cover'
  },
  primaryBtnWrapper: {
    textAlign: 'right',
    paddingTop: 32,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      paddingTop: 8,
    },
  },
  secondaryBtnWrapper: {
    textAlign: 'left',
    paddingTop: 32,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      paddingTop: 8,

    },
  },
}));
